import './CloseButton.css';
import React from 'react';
import { IconClose } from '../../04_Audio/icons';
import { IconCloseCircle } from '../Icons';
export const CloseButton = _ref => {
  let {
    onClick,
    className,
    isCircleButton
  } = _ref;
  return /*#__PURE__*/React.createElement("button", {
    "aria-label": "Close" //TODO: remove hardcode
    ,

    className: `${commonStyles} ${className ? className : ''}`,
    onClick: onClick
  }, isCircleButton ? /*#__PURE__*/React.createElement(IconCloseCircle, {
    "aria-hidden": "true"
  }) : /*#__PURE__*/React.createElement(IconClose, {
    className: "default-icon",
    "aria-hidden": "true"
  }));
};
const commonStyles = "cxuz672";